var _rect, _rect2, _circle, _rect3, _rect4, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowerList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 300,
    viewBox: "0 0 390 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 71,
    width: 223,
    height: 12,
    rx: 2,
    fill: "#EEE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 35,
    width: 149,
    height: 24,
    rx: 2,
    fill: "#EEE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 59,
    r: 24,
    fill: "#EEE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 165,
    width: 223,
    height: 12,
    rx: 2,
    fill: "#EEE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 129,
    width: 149,
    height: 24,
    rx: 2,
    fill: "#EEE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 153,
    r: 24,
    fill: "#EEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y50qzrgp4a)",
    d: "M0 0h390v300H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "y50qzrgp4a",
    x1: 195,
    y1: -105.682,
    x2: 195,
    y2: 225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowerList);
export default __webpack_public_path__ + "static/media/follower_list.33ed5460d568bfd90621fecef7de7f62.svg";
export { ForwardRef as ReactComponent };